import React from 'react';
import './Header.css';
import Spiky from './Spiky.png';

function Header() {
  return (
    <div className="header container">
      <div className="row">
        <div className="col-12 col-md-5 header__left">
          <div>
            <h1 className="header__name">Anum Mujahid</h1>
            <h2 className="header__title">
              I am a{' '}
              <span className="headertitle__color">Web Developer</span>
            </h2>
            <p className="header__detail">
              Software Engineer | Graduated from NUST | Web Developer | Problem Solver |
              Workaholic | Dedicated | Goal Oriented | Daughter | Crazy Sister | Foodie | Pasta Lover
              | No Coffee | Love to Code | Mentor of an amazing Software
              Engineer | Introvert | Painter | Big Dreams
            </p>
          </div>
        </div>
        <div className="col-12 col-md-7 header__right">
          <div className="header__imgcircle imgcircle--position1">
            <i className="fab fa-react"></i>
          </div>
          <div className="header__imgcircle imgcircle--position2">
            <i className="fab fa-envira"></i>
          </div>
          <div className="header__imgcircle imgcircle--position3">
            <i className="fab fa-js-square"></i>
          </div>
          <div className="header__imgcircle imgcircle--position4">
            <i className="fab fa-css3-alt"></i>
          </div>
          <div className="header__imgcircle imgcircle--position5">
            <i className="fab fa-html5"></i>
          </div>
          <div className="header__imgcircle imgcircle--position6">
            <i className="fab fa-git-alt"></i>
          </div>
          <div className="header__imgcircle imgcircle--position7">
            <i className="fab fa-github"></i>
          </div>
          <div className="header__imgcircle imgcircle--position8">
            <i className="fab fa-node-js"></i>
          </div>
          <img src={Spiky} alt="Anum's avatar Spiky" className="header__img" />
        </div>
      </div>
    </div>
  );
}

export default Header;
